import { useCallback, useState, useRef } from "react";
import { readStore, writeStore } from "../../../../../shared/lib/localStore";
import { useForwardWhatsAppMessage } from "../../../../client/hooks/useWhatsAppData";

const WIDTH_KEY = "whatsapp_info_panel_width";
const MIN_W = 380;
const MAX_W = 900;

// integración main→dev, epic B2 — orquesta las acciones de mensaje que WhatsPanel.jsx no tiene
// espacio para llevar inline: responder / reenviar, el panel derecho (perfil + preview de media
// a pantalla completa) y su ancho redimensionable (persistido en localStore). Estado de UI, no
// server-state — vive acá y no en un store global.
export function useWhatsMessageActions() {
  const [replyingToMsg, setReplyingToMsg] = useState(null);
  const [forwardingMsg, setForwardingMsg] = useState(null);
  const [activeRightPanel, setActiveRightPanel] = useState(null);
  const [standaloneTaskId, setStandaloneTaskId] = useState(null);
  const [infoPanelWidth, setInfoPanelWidth] = useState(
    () => readStore(WIDTH_KEY, { fallback: 700 }),
  );

  const forwardMutation = useForwardWhatsAppMessage();

  const clearReply = useCallback(() => setReplyingToMsg(null), []);
  const startForward = useCallback((msg) => setForwardingMsg(msg), []);
  const cancelForward = useCallback(() => setForwardingMsg(null), []);

  const doForward = useCallback((targetJid) => {
    if (!forwardingMsg) return;
    forwardMutation.mutate({ targetJid, msgId: forwardingMsg.msg_id });
    setForwardingMsg(null);
  }, [forwardingMsg, forwardMutation]);

  const openMediaPanel = useCallback(({ url, filename, mime }) => {
    setActiveRightPanel({ type: "media", url, filename, mime, label: filename });
  }, []);

  const originalPathRef = useRef(null);

  const openTaskPanel = useCallback((taskId) => {
    setStandaloneTaskId(taskId);
    if (taskId) {
      if (!originalPathRef.current) {
        originalPathRef.current = window.location.pathname;
      }
      const pathParts = window.location.pathname.split('/').filter(Boolean);
      const space = pathParts[0] || 'frqtal';
      window.history.pushState({ isStandaloneTask: true }, '', `/${space}/${taskId}${window.location.hash}`);
    } else {
      if (originalPathRef.current) {
        window.history.pushState(null, '', `${originalPathRef.current}${window.location.hash}`);
        originalPathRef.current = null;
      }
    }
  }, []);

  const resizeInfoPanel = useCallback((deltaPx) => {
    setInfoPanelWidth((prev) => {
      const next = Math.min(MAX_W, Math.max(MIN_W, prev + deltaPx));
      writeStore(WIDTH_KEY, next);
      return next;
    });
  }, []);

  return {
    replyingToMsg, setReplyingToMsg, clearReply,
    forwardingMsg, startForward, cancelForward, doForward,
    activeRightPanel, setActiveRightPanel, openMediaPanel, openTaskPanel,
    standaloneTaskId, setStandaloneTaskId,
    infoPanelWidth, resizeInfoPanel,
    // parámetros para el mutation-de-enviar cuando hay una cita activa
    replyPayload: replyingToMsg ? {
      quotedMsgId: replyingToMsg.msg_id,
      quotedMsgText: replyingToMsg.text_content,
      quotedSenderJid: replyingToMsg.sender_jid || null,
    } : {},
  };
}
